export const TOGGLE_MINI_CART = 'BEAMLY/CCX/TOGGLE_MINI_CART';
